import { render, staticRenderFns } from "./device-model.vue?vue&type=template&id=0045fd4e&"
import script from "./device-model.vue?vue&type=script&lang=js&"
export * from "./device-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0045fd4e')) {
      api.createRecord('0045fd4e', component.options)
    } else {
      api.reload('0045fd4e', component.options)
    }
    module.hot.accept("./device-model.vue?vue&type=template&id=0045fd4e&", function () {
      api.rerender('0045fd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/device-model/device-model.vue"
export default component.exports